module.exports = __webpack_public_path__ + "assets/img/block-62def5ec.png";